const entity = {
    create_failed: '建立 {{name}} 失敗。',
    not_exists: '{{name}} 不存在。',
    not_exists_with_id: 'ID 為 `{{id}}` 的 {{name}} 不存在。',
    not_found: '資源不存在。',
};
export default entity;
